import React, { useRef } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import Breadcrumb from "../../../shared/components/atoms/breadcrumb/breadcrumb"
import FavoriteProducts from "../../../shared/components/molecules/favorite-products/favorite-products"
import SectionConsulting from "../../../shared/components/molecules/section-consulting/section-consulting"
import CardsSubcategory from "../../molecules/cards-subcategory/cards-subcategory"
import HeaderCategory from "../../molecules/header-category/header-category"
import Recommender from "../../molecules/recommender/recommender"
import YouCanUse from "../../molecules/you-can-use/you-can-use"
import "./category-products.scss"

const scrollToRef = ref =>
  window.scrollTo(0, ref.current.offsetTop, "easeInBounce")

const CategoryProducts = props => {
  const resultQuery = useStaticQuery(
    graphql`
      query CATEGORY_CHAT_BUTTON_QUERY {
        allContentfulNolPaises(filter: { node_locale: { eq: "es-CO" } }) {
          nodes {
            codigoIcu
            tieneTienda
          }
        }
        allContentfulNolHome {
          nodes {
            node_locale
            hayLanzamiento
          }
        }
      }
    `
  )

  const haveShop = resultQuery.allContentfulNolPaises.nodes.filter(
    e => e.codigoIcu === process.env.LOCALE
  )[0].tieneTienda
  const haveRelease =
    props.params.lanzamientoDeProducto === "Hay lanzamiento de nuevo producto"

  const myRef = useRef(null)
  const [pageLoad, setPageLoad] = React.useState(false)

  React.useEffect(() => {
    setPageLoad(true)
  }, [])

  return (
    <div className="f-CategoryProducts">
      <div className="f-breadcrum-position">
        <Breadcrumb mobile={props.mobile} />
      </div>
      <div className="f-CategoryProducts-content">
        <div className="f-CategoryProducts-content-header">
          <Img
          loading="eager"
            className="f-CategoryProducts-content-header-banner "
            alt={props.params.banner.bannerSecciones[1].description}
            fluid={[
              props.params.banner.bannerSecciones[0].fluid,
              {
                media: `(max-width: 1024px)`,
                ...props.params.banner.bannerSecciones[1].fluid,
              },
            ]}
          />
          <h1 className="f-CategoryProducts-content-header-copy">
            {props.params.banner.tituloBanner}
          </h1>
        </div>
        <HeaderCategory
          menu={props.menu}
          active={props.params.titulo}
          mobile={props.mobile}
        />
        {haveRelease && (
          <div className="f-CategoryProducts-content-header-product">
            {props.mobile && props.params.imagenLanzamientoDeProducto && (
              <a
                href={
                  props.params.redireccionLanzamientoProducto !== null
                    ? props.params.redireccionLanzamientoProducto
                    : "#"
                }
              >
                <img
                  alt={props.params.imagenLanzamientoDeProducto[1].description}
                  src={
                    pageLoad
                      ? props.params.imagenLanzamientoDeProducto[1].file.url
                      : props.params.imagenLanzamientoDeProducto[1].fixed.base64
                  }
                />
              </a>
            )}
            {!props.mobile && props.params.imagenLanzamientoDeProducto && (
              <a
                href={
                  props.params.redireccionLanzamientoProducto !== null
                    ? props.params.redireccionLanzamientoProducto
                    : "#"
                }
              >
                <img
                  alt={props.params.imagenLanzamientoDeProducto[0].description}
                  src={
                    pageLoad
                      ? props.params.imagenLanzamientoDeProducto[0].file.url
                      : props.params.imagenLanzamientoDeProducto[0].fixed.base64
                  }
                />
              </a>
            )}
          </div>
        )}
        <CardsSubcategory
          haveRelease={haveRelease}
          onClickReference={() => scrollToRef(myRef)}
          subcategories={props.params.subcategoriasProductos}
          category={props.params.slug}
          descubreProductoIdeal={props.params}
        />
        {props.params.tambienPuedesUsar && (
          <YouCanUse products={props.params.tambienPuedesUsar} />
        )}
        <div className="f-slug-fix" ref={myRef}></div>
        {props.params.descripcionProductoIdeal && (
          <Recommender
            slug={props.params.slug}
            test={props.params.recomendador}
          />
        )}
        <SectionConsulting mobile={props.mobile} home={false} />
        {haveShop && <FavoriteProducts mobile={props.mobile} />}
      </div>
    </div>
  )
}

export default CategoryProducts
